import React from 'react';

import { type PartnerDto } from '@/common/types/query/tasks';
import { H1 } from '@/components/Typography/Typography';

import PartnersTaskItem from './PartnersTaskItem';

import css from './style.module.scss';

interface PartnersTaskProps {
  partners: PartnerDto[];
}

const PartnersTask: React.FC<PartnersTaskProps> = ({ partners }) => {
  return (
    <div className={css.partner}>
      {partners?.map((el) => (
        <div key={el.id} className={css.partnerBlock}>
          <H1>{el.name}</H1>
          <div className={css.taskBlock}>
            {el.partnerTask.map((prop) => (
              <PartnersTaskItem key={prop.id} {...prop} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PartnersTask;
